export default __webpack_public_path__ + "static/media/Wolf's Gloves of the Wicked Hearth.54d4da51.jpg";